import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Stack,
  CircularProgress,
  Backdrop,
  Box,
  Snackbar,
  Alert,
  useMediaQuery
} from '@mui/material';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import { faCoinVertical } from '@fortawesome/pro-regular-svg-icons';
import { useClientApi } from '../../../api/client';
import { CLIENT_TYPES } from '../../../api/clientconfig';

const ResultsDialog = ({ isHandleOverlayVisibilty }) => {
  const sessionId = localStorage.getItem('session-id');
    const isSmallScreen = useMediaQuery( '(max-width:499px)' );
  const clientApi = useClientApi(CLIENT_TYPES.DOKTOR_CONNECT, sessionId);
  const [open, setOpen] = useState(false);
  const [earnCreditsDialogOpen, setEarnCreditsDialogOpen] = useState(false);
  const [gameUrl, setGameUrl] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState(60);
   const [message, setMessage] = useState(undefined);
  const [progress, setProgress] = useState(100); // 100% at the start
  const [isGameTimerActive, setIsGameTimerActive] = useState(false);
  const [isOverlayVisible, setIsOverlayVisible] = useState(false);
  const [waitingCheckoutLink, setWaitingCheckoutLink] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // const handleOpenEarnCreditsDialog = () => setEarnCreditsDialogOpen(true);
  const handleCloseEarnCreditsDialog = () => setEarnCreditsDialogOpen(false);

  const results = [
    {
      title: 'Physical Health',
      description: 'Facial skin age, body shape index, body mass index, estimated waist size.'
    },
    {
      title: 'Disease Risk',
      description: 'Heart attack risk, hypercholesteremia risk, cardiovascular disease risk, & stroke risk.'
    },
    // {
    //   title: 'Liver Health',
    //   description: 'Fatty liver disease risk & hypertriglyceridemia risk'
    // },
    {
      title: 'Diabetes Risk',
      description: 'Risk of high HbA1c, fasting blood glucose, & type || diabetes risk.'
    }
  ];

  const handleOpenEarnCreditsDialog = () => {
    setOpen(false)
    handleOpenGame()
  }
  useEffect(() => {
    setProgress((timeRemaining / 60) * 100); // Calculate the progress percentage
  }, [timeRemaining]);


  const handleOpenGame = async () => {
    const sessionId = localStorage.getItem('session-id');
    try {
      // Step 1: Fetch game data from the API
      const games = await clientApi.getGameZopGames(sessionId);
      setIsOverlayVisible(true);
      isHandleOverlayVisibilty(true)
      // Step 2: Get a random game URL 
      const randomGame = games.data.games[Math.floor(Math.random() * games.data.games.length)];
      const gameUrl = `${randomGame.url}?sub=${sessionId}`; // Main game URL to redirect to
      console.log(gameUrl);

      setGameUrl(gameUrl);

      // Step 3: Open the game in a new tab
      const gameWindow = window.open(gameUrl, '_blank'); // Open game in a new tab

      setIsGameTimerActive(true);

      // Step 4: Set a timer in the original page to redirect after 60 seconds
      const timeoutId = setTimeout(() => {
        // Redirect back to the original page after 60 seconds
        if (window.opener) {
          // If opener exists (meaning we came from another window)
          window.opener.location.href = window.location.href; // Redirect back to the original page
        } else {
          // If no opener, fallback to a default URL
          const fallbackUrl = window.location.hostname === 'localhost'
            ? 'http://localhost:3000/results'
            : 'https://my.ai-md.com/results';

          window.location.href = fallbackUrl;
        }

        // Close the new game window after 60 seconds
        if (gameWindow) {
          gameWindow.close(); // Close the game window after 60 seconds
        }

        // Store isGamePlayed as true in sessionStorage after 1 minute
        sessionStorage.setItem('isGamePlayed', 'true');
        setIsGameTimerActive(false);
        isHandleOverlayVisibilty(false)
        // sessionStorage.removeItem('isGameTimerActive');
        setIsOverlayVisible(false);
      }, 60000);

      let initialTime = 60; // starting time in seconds

      const intervalId = setInterval(() => {
        setTimeRemaining((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(intervalId); // Stop the countdown when it reaches 0
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000); // Update every second

      // Keep the progress bar synced with the time remaining
      setProgress(100); // Initial progress is 100%

      const progressInterval = setInterval(() => {
        setProgress((prevProgress) => {
          const newProgress = (timeRemaining / initialTime) * 100;
          return newProgress;
        });
      }, 1000);

    } catch (err) {
      setIsOverlayVisible(false);
      isHandleOverlayVisibilty(false);
      setIsGameTimerActive(false);
      console.error("Error fetching games:", err); // Log the error if something goes wrong
    }
  };


  const payHandler = async () => {
    try {
      setWaitingCheckoutLink(true);
      // Make the API call to get the checkout link
      const checkoutLinkReq = await clientApi.postOneTimeCheckoutForDoktor();
      console.log(checkoutLinkReq);
      // If the status code is not 200, handle the error
      if (checkoutLinkReq.status !== 200) {
        setWaitingCheckoutLink(false);
        setMessage('An error occurred. Please try later.');
        return;
      }
      // If successful, redirect to the checkout link
      const link = checkoutLinkReq.data.redirect_url;
      window.location.href = link;
    } catch (error) {
      console.error('Payment error:', error);
      setWaitingCheckoutLink(false);
      setMessage('An unexpected error occurred. Please try again later.');
    }
  };


  return (
    <>
      <Button
        fullWidth
        onClick={handleOpen}
        sx={{
          fontWeight: 600,
          fontSize: '20px',
          textAlign: 'center',
          background: '#0633CB',
          // maxWidth: '230px', 
          width: "100%",
          maxWidth : "400px", 
          height: '57px', 
          borderRadius : "10px",
          color:"#fff",
          "&:hover": {
          color : "black"
        },
        }}
      >
        <Typography
          variant="p"
          component="p"
          fontWeight="600"
          className='btn-txt'
          sx={{
           
              fontSize: isSmallScreen ? '16px' : '20px',
          
            '&:hover': {
              color: 'black', // Ensures the text color is white on hover
            },
          }}

        >
          {isGameTimerActive ?
            <Box display="flex" justifyContent="center" alignItems="center">
              <Typography>Play a game to reveal results</Typography>
              <Box sx={{ position: 'relative', display: 'inline-flex', justifyContent: 'end', alignItems: 'center', marginLeft: "10px" }}>
                <CircularProgress
                  variant="determinate"
                  value={progress}
                  size={50}
                  thickness={4}
                />
                <Typography
                  color="black"
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontWeight: '500',
                    fontSize: '16px',
                    textAlign: 'center',
                  }}
                >
                  {timeRemaining}s
                </Typography>
              </Box>
            </Box>
            :
            "Reveal My Results"

          }


        </Typography>
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
       
        PaperProps={{
          sx: {
            borderRadius: '15px',
            maxWidth : { xs : "350px" , md : "350px",sm : "350px", lg : "500px"},
            margin : { xs : 1}
          },
        }}
      >
        <DialogTitle>
          <Stack spacing={1} display="flex" justifyContent="center" width="100%" >
            <Typography variant="h6"   
            sx={{
              color:"#242B68",
              fontWeight:"700",
              fontSize:{
                xs : "26px",
                lg : "30px"
              },
              textAlign:"center"
            }}>
              Reveal your results
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'center',color: '#000000',fontWeight: "700", fontSize:"15px" }}>
              <FontAwesomeIcon icon={faCoinVertical} style={{ color: '#FFD700' }} /> Your credits: 5
            </Typography>
            <Typography
              variant="caption"
              color="primary"
              sx={{ cursor: 'pointer',  textAlign:"center", color:"#0733C5" }}
              onClick={handleOpenEarnCreditsDialog}
            >
              Play brain games to get more credits →
            </Typography>
          </Stack>
        </DialogTitle>

        <DialogContent>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 ,display : "flex", justifyContent : "space-between"}} >
          <Typography sx={{
            fontWeight: "600",
            fontSize: "17px"
            
          }}> Premium Vitals Results  </Typography>
            <Typography component="span" sx={{ ml: 1, display: 'inline-flex', alignItems: 'center', gap: 0.5 ,fontWeight: "600",fontSize: "17px"}}>
              <FontAwesomeIcon icon={faCoinVertical} style={{ color: '#FFD700' }} /> 25
            </Typography>
          </Typography>
          <Typography variant="body2" color="#000000" sx={{ fontWeight : "500", fontSize : "12px"}}>
            Scan 22 different vitals metrics
          </Typography>

          <List>
            {results.map((result, index) => (
              <ListItem key={index} sx={ { pb : 0, pt : 0, px : 1}}>
                {/* <ListItemIcon sx={{ display: 'flex', alignItems:'flex-start',justifyContent : 'start' }}>
                  <FontAwesomeIcon
                    icon={faCircleCheck}
                    style={{ color: '#0633CB', fontSize: '20px' }}
                  />
                </ListItemIcon> */}
                <ListItemText
                  primary={
                  <Box flexDirection="row" alignItems="center" display="flex" >
                    <FontAwesomeIcon
                    icon={faCircleCheck}
                    style={{ color: '#0633CB', fontSize: '20px',marginRight: '8px' }}
                    />
                     <Typography fontSize="16px" fontWeight="500" >{result.title} </Typography>
                  </Box>
                  }
                  secondary={
                    <Typography
                      component="span"
                      sx={{
                        fontSize: "15px",
                        lineHeight: "18px",
                        display: 'block',
                        marginLeft: "27px",
                        fontWeight : 500,
                        color : "#565656",
                      }}
                    >
                      {result.description}
                    </Typography>
                    
                  }
                />
              </ListItem>
            ))}
          </List>

          <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
            <Button
              variant="contained"
              fullWidth
              sx={{
                borderRadius: '5px',
                background: '#10ECBC',
                fontWeight: 600,
                color: "#00000",
                '&:hover': {
                  background: '#10ECBC'
                }
              }}
              onClick={payHandler}
            >
              PAY $1 USD
            </Button>
            <Button
              variant="outlined"
              fullWidth
              onClick={handleOpenEarnCreditsDialog}
              sx={{
                borderRadius: '5px',
                background: '#565656',
                color: '#10ECBC'

              }}
            >
              Earn Credits
            </Button>
          </Stack>

          <Typography
            variant="body2"
            color="text.secondary"
            align="start"
            sx={{ mt: 2, cursor: 'pointer' }}
            onClick={handleClose}
          >
            ← Go back to my results
          </Typography>
        </DialogContent>
        <Snackbar
        autoHideDuration={3000}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={message !== undefined}
        onClose={() => {
          setMessage(undefined);
        }}
      >
        <Alert
          severity="error"
          sx={{
            mt: 0.5,
            mb: 6,
            alignSelf: 'center',
            width: '90%', //even though is not 100% it looks like it is
            textAlign: 'center',
          }}
        >
          {message}
        </Alert>
      </Snackbar>
 
      </Dialog>
    </>
  );
};

export default ResultsDialog;